import PayoffStaticPoolAnalysis from './PayoffStaticPoolAnalysis';

export default PayoffStaticPoolAnalysis;
